import React from "react";
import { apiGateway } from "../utils/config";
import { axiosPublic } from "../api/axiosCustom";
import { RouteName } from "../utils/route.utils";
import FaqAccordion from "../components/v3/components/Common/FaqAccordion";
import Head from "next/head";
import TAGS from "../public/headJson.json";
import Footer from "../components/v3/components/Common/Footer";
import Header from "../components/v3/components/Header";
import withUserInformation from "../HOC's/withUserInformation";

const FAQPage = ({ faqData }) => {
  const structData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqData?.map((faq) => {
      return {
        "@type": "Question",
        name: faq?.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: faq?.answer,
        },
      };
    }),
  };

  return (
    <>
      <Head>
        {/* Primary Meta Tags */}
        <title>{TAGS.faq.title}</title>
        <meta name="title" content={TAGS.faq.title} />
        <meta name="description" content={TAGS.faq.description} />
        <link rel="canonical" href={RouteName.faq} />

        {/* Facebook / Open Graph */}
        <meta property="og:url" content={RouteName.faq} />
        <meta property="og:title" content={TAGS.faq.title} />
        <meta property="og:description" content={TAGS.faq.description} />
        <meta property="og:image" content={TAGS.landingPage.imageUrl} />
        <meta property="og:image:alt" content="Seekho" />

        {/* Twitter */}
        <meta property="twitter:url" content={RouteName.faq} />
        <meta property="twitter:title" content={TAGS.faq.title} />
        <meta property="twitter:description" content={TAGS.faq.description} />
        <meta property="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@seekhoapp" />
        <meta property="twitter:image" content={TAGS.landingPage.imageUrl} />

        <script
          key="faq-page"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(structData) }}
        />
      </Head>

      <div>
        <Header />
      </div>

      <div className="text-white pt-14">
        <h2 className="text-center text-[32px] w-[90%] mx-auto !pt-3 lg:!pt-10">
          Frequently Asked Questions
        </h2>
        <div className="pt-4 w-[90%] mx-auto lg:!w-[60%]">
          <FaqAccordion faq={faqData} />
        </div>

        <div className="mt-10">
          <Footer />
        </div>
      </div>
    </>
  );
};

export const getStaticProps = async () => {
  try {
    const url = `${apiGateway}/api/v1/home/website/`;
    const response = await axiosPublic.get(url);
    return {
      props: {
        faqData: response?.data?.faqs,
      },
      revalidate: 86400, // revalidate after 1Day
    };
  } catch (error) {
    return {
      notFound: true,
      revalidate: true,
    };
  }
};

export default withUserInformation(FAQPage);
